import React from 'react';
import { Line } from 'react-konva';
import { relatedColor, unrelatedColor, lineCap, strokeWidth, cornerBuffer } from '../../library/constants';

const BaseComponent = ( {union, nodeObjs, xHandlePos, endYOfHandle, unionColor, stageBackgroundCustomColor} ) => {
  const isOnlyChildAndAlsoRelated = union.c.length === 1 && nodeObjs[union.c[0]]['d_r'] === 1;
  let color = ( isOnlyChildAndAlsoRelated ? relatedColor: unrelatedColor);

  color = typeof(stageBackgroundCustomColor) !== 'undefined' && stageBackgroundCustomColor === '#000000' ? '#FFFFFF': color;

  if(typeof(unionColor) !== 'undefined') color = unionColor;
  let yBasePos = endYOfHandle;
  const children = union.c;
  const xCenters = children.map( (child) => nodeObjs[child].xCenter );
  let startBaseX = Math.min(...xCenters);
  let endBaseX = Math.max(...xCenters);

  startBaseX = ( xHandlePos < startBaseX ? xHandlePos : startBaseX) - cornerBuffer;
  endBaseX = ( xHandlePos > endBaseX ? xHandlePos : endBaseX) + cornerBuffer;

  const coordinates = [startBaseX, yBasePos, endBaseX, yBasePos];
  return (
    <Line
      points = {coordinates}
      stroke = {color}
      strokeWidth = {strokeWidth}
      lineCap = {lineCap}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};

export default BaseComponent;
